import React, { useState, useEffect } from "react";
import axios from "axios";
import { Frenchisee } from "../../../src/Configuration/Frenchisee_URL";
import ComplianceApplicationStatus from "../../Components/ComplianceDashboardComp/ComplianceApplicationStatus";
import ComplianceDetailsPreview from "../../Components/ComplianceDashboardComp/ComplianceDetailspreview";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { decryptData } from "../../CommonMethhods/CommonMethods";

function ComplianceApplicationStatusDashboard(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [frenchiseeDatails, setFrenchiseeDatails] = useState([]);
  const [loader, setLoader] = useState(true);
  if (storeToken == null) {
    window.location.replace("/");
  }

  const getFrenchiseeId = async () => {
    let id = localStorage.getItem("complianceId");
    try {
      const getDetail = await axios.get(
        `${Frenchisee.GET_FRENCHISEE_ID}?id=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = decryptData(getDetail.data);
      let getIdResp = JSON.parse(res);
      if (typeof getIdResp.data.info == "object") {
        setFrenchiseeDatails(getIdResp.data.info);
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getFrenchiseeId();
  }, []);

  return (
    <>
      <Header headerDetails={frenchiseeDatails} portal={"TELECALLER"} />
      <SingleSignOnSideBar />

      <main id="main-content">
        <ComplianceApplicationStatus
          frenchiseeDatails={frenchiseeDatails}
          loader={loader}
        />

        <ComplianceDetailsPreview frenchiseeDatails={frenchiseeDatails} />
      </main>
    </>
  );
}

export default ComplianceApplicationStatusDashboard;
